import { useCeResource } from './useCeResource';
import { PerksProgram } from './const';

export function useGetPerksProgram(shouldFetch: boolean, merchantId?: string) {
  const [loading, perksProgram, error] = useCeResource<PerksProgram>(() => shouldFetch && merchantId && ({
    url: `/2/cma/merchant/program/${merchantId}`,
  }), [merchantId]);

  return { loading, perksProgram, error };
}
